// extracted by mini-css-extract-plugin
export default {"cls1":"DVf66BwgpVz1DhFPv3yA","cls2":"ZqBsXA_6BtH9xLnKUv59 DVf66BwgpVz1DhFPv3yA"};